<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <h3 class="text-sm font-bold leading-6 tablet:text-base tablet:leading-7">
      <TheNuxtLink
        :to="item.pageUrl"
        :title="item.title"
        class="line-clamp-2 hover:text-blue-400"
      >
        <span v-html="provideMarkerText(item.title, keyword)" />
      </TheNuxtLink>
    </h3>
    <p
      v-if="hasDescription && item.description"
      class="mt-3 line-clamp-2 text-xs leading-5 text-gray-700 tablet:text-sm tablet:leading-6"
      v-html="provideMarkerText(item.description, keyword)"
    />
  </div>
</template>

<script setup lang="ts">
  import type { ISearchItem } from '@/assets/types/api/Search';

  withDefaults(
    defineProps<{
      item: ISearchItem;
      keyword: string;
      hasDescription?: boolean;
    }>(),
    { hasDescription: true }
  );
</script>
